import React from 'react';
import { Plus } from 'lucide-react';
import KnowledgeCard from './KnowledgeCard';

interface KnowledgeGridProps {
  knowledgeItems: any[];
  searchText: string;
  onCreateNew?: () => void;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  onSettings?: (id: string) => void;
}

const KnowledgeGrid: React.FC<KnowledgeGridProps> = ({
  knowledgeItems,
  searchText,
  onCreateNew,
  onEdit,
  onDelete,
  onSettings
}) => {
  const safeItems = Array.isArray(knowledgeItems) ? knowledgeItems : [];
  return (
    <div className="p-3 sm:p-4 md:p-6">
      {/* Create New Knowledge Card */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
        <div
          onClick={onCreateNew}
          className=" bg-white border-2 border-dashed border-gray-300 rounded-lg shadow-sm hover:shadow-md hover:border-blue-400 transition-all duration-200 p-4 sm:p-6 cursor-pointer group max-h-[180px] sm:max-h-[200px] flex gap-2 items-center justify-center"
        >
          <div className="w-8 h-8 sm:w-10sm:h-10 bg-blue-50 group-hover:bg-blue-100 rounded-lg flex items-center justify-center mb-3 sm:mb-4 transition-colors duration-200">
            <Plus className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
          </div>
          <h3 className="text-sm sm:text-base text-gray-900 mb-3 text-center">Create Knowledge</h3>
          {/* <p className="text-xs sm:text-sm text-gray-500 text-center leading-relaxed">
            Import your own text data or write data in real-time via Webhook for LLM context enhancement.
          </p> */}
        </div>

        {/* Knowledge Cards */}
        {safeItems.map((item) => (
          <KnowledgeCard
            key={item.id}
            knowledge={item}
            onEdit={onEdit ? () => onEdit(item.id) : undefined}
            onDelete={onDelete ? () => onDelete(item.id) : undefined}
            onSettings={onSettings ? () => onSettings(item.id) : undefined}
          />
        ))}
      </div>

      {/* Empty State */}
      {safeItems.length === 0 && searchText && (
        <div className="text-center py-8 sm:py-12 px-4">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Plus className="w-6 h-6 sm:w-8 sm:h-8 text-gray-400" />
          </div>
          <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-2">No knowledge found</h3>
          <p className="text-sm sm:text-base text-gray-500 mb-4 max-w-md mx-auto">
            No knowledge items match your search criteria "{searchText}"
          </p>
          <button
            onClick={onCreateNew}
            className="inline-flex items-center px-3 py-2 sm:px-4 sm:py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 text-sm sm:text-base"
          >
            <Plus className="w-4 h-4 mr-2" />
            Create New Knowledge
          </button>
        </div>
      )}

      {/* Results count */}
      {searchText && safeItems.length > 0 && (
        <div className="mt-4 sm:mt-6 text-xs sm:text-sm text-gray-500 px-2">
          Found {safeItems.length} knowledge item{safeItems.length !== 1 ? 's' : ''} matching "{searchText}"
        </div>
      )}
    </div>
  );
};

export default KnowledgeGrid;
